/** Otel + uçak ödeme kartı — ortak formatlama */

export const expiryYearOptions = () =>
  Array.from({ length: 12 }, (_, i) =>
    (new Date().getFullYear() + i).toString().slice(-2)
  );

export const expiryMonthOptions = () =>
  Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));

export function formatCardNumberInput(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 16);
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
}

export function parseCardDigits(cardNumber) {
  return String(cardNumber || '').replace(/\D/g, '');
}

/** Uçak API: expire_year tam yıl (2028) */
export function buildFlightPaymentCardPayload(card) {
  const card_number = parseCardDigits(card.card_number);
  let yearRaw = String(card.expire_year || '').replace(/\D/g, '');
  if (yearRaw.length === 2) yearRaw = `20${yearRaw}`;
  const expire_year = parseInt(yearRaw, 10);
  const expire_month = parseInt(card.expire_month, 10);
  return {
    card_number,
    expire_month,
    expire_year,
    cvc: String(card.cvc || '').replace(/\D/g, '').slice(0, 4),
    full_name: String(card.full_name || '').trim().toUpperCase(),
  };
}

/** Ziraat: expiry_year 2 hane (YY) */
export function buildZiraatCardPayloadFromForm(card) {
  const card_number = parseCardDigits(card.card_number);
  let year = String(card.expire_year || card.expiry_year || '').replace(/\D/g, '');
  if (year.length === 4) year = year.slice(-2);
  return {
    card_number,
    card_holder: String(card.card_holder || card.full_name || '').trim().toUpperCase(),
    expiry_month: String(card.expire_month || card.expiry_month || '').padStart(2, '0'),
    expiry_year: year,
    cvv: String(card.cvv || card.cvc || '').replace(/\D/g, ''),
  };
}

export function validatePaymentCard(card, { requireHolder = true } = {}) {
  const digits = parseCardDigits(card.card_number);
  if (!digits || digits.length < 15 || digits.length > 16) {
    return 'Geçerli bir kart numarası giriniz (15-16 hane)';
  }
  const month = card.expire_month || card.expiry_month;
  const year = card.expire_year || card.expiry_year;
  if (!month || !year) {
    return 'Kart son kullanma tarihini seçiniz';
  }
  const cvv = String(card.cvc || card.cvv || '').replace(/\D/g, '');
  if (cvv.length < 3) {
    return 'CVV kodunu giriniz';
  }
  const holder = String(card.full_name || card.card_holder || '').trim();
  if (requireHolder && holder.length < 3) {
    return 'Kart üzerindeki ismi giriniz';
  }
  return null;
}
